module.exports = __webpack_public_path__ + "static/media/Ajit_Venkatraman.16e36c41.png";